import { render, staticRenderFns } from "./app.vue?vue&type=template&id=c2f1b2dc"
import script from "./app.vue?vue&type=script&lang=js"
export * from "./app.vue?vue&type=script&lang=js"
import style0 from "./app.vue?vue&type=style&index=0&id=c2f1b2dc&prod&lang=css"
import style1 from "./app.vue?vue&type=style&index=1&id=c2f1b2dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports